const initialState = {
    modalName: null,
    modalProps: {
        modalIsOpen: false,
    },
};

export default function modal(state = initialState, action) {
    switch (action.type) {
        case 'SHOW_MODAL':
            return {
                ...state,
                modalName: action.modalName,
                modalProps: {
                    ...action.modalProps,
                    modalIsOpen: true,
                },
            };
        case 'SWITCH_MODAL':
            return {
                ...state,
                modalName: action.modalName,
                modalProps: {
                    ...state.modalProps,
                    ...action.modalProps,
                    modalIsOpen: true,
                },
            };
        case 'HIDE_MODAL':
            return {
                ...state,
                modalName: action.modalName,
                modalProps: {
                    ...initialState.modalProps,
                },
            };
        default:
            return state;
    }
}
